import type {TChangePasswordParams} from '@kapitalist/contract/endpoints'
import {endpoints} from '@kapitalist/contract/endpoints'
import type {TFormError} from '@kapitalist/contract/types'
import type {EmptyObject} from '@kapitalist/utils/EmptyObject'
import {PostApi} from '~/api/client'

export type TChangePasswordResponse = EmptyObject

const endpoint = endpoints.account.changePassword

export default class ChangePassword extends PostApi<typeof endpoint>() {
  constructor() {
    super(endpoint)
  }

  protected mockRequestFailure(params: TChangePasswordParams): TFormError | null {
    if (params.currentPassword === 'failfailfail') {
      return {errors: {currentPassword: [`That password isn't right.`]}}
    }
    return null
  }

  protected getMockResponse(): EmptyObject {
    return {}
  }

  protected transformResponse(r: EmptyObject) {
    return r
  }
}
